module.exports = __webpack_public_path__ + "img/doc_active_orange.0e4fd5b0.svg";